<template>
<div>
    <h3 class="text-center" style="text-transform: uppercase">Hóa đơn trả cọc</h3>
    <table class="mx-auto">
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Số phòng</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.room_id }}</td>
        </tr>
        <tr v-if="is_date_out_and_date_schedule_out_different_month">
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Ngày hẹn trả (tính tiền phòng)</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ date_schedule_out | formatTimeVN }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">{{ is_date_out_and_date_schedule_out_different_month ? 'Ngày thực trả (tính tiền dịch vụ)' : 'Ngày ra' }}</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.date_out | formatTimeVN }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">
                Số ngày 
                (Từ {{ startDate | formatTimeVN }} đến {{ date_schedule_out | formatTimeVN }})
            </td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.date_count }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                Tiền phòng
            </td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá</td>
            <td class="text-right">{{ bill.room_price | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.room_bill | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                Tiền điện
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">{{ bill.electric_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu kỳ ({{ bill.room_bill_with_debts.electric.startDate | formatTimeVN }})</td>
                <td class="text-right text-no-wrap" v-if="electric_meter_change"> {{ bill.room_bill_with_debts.electric.start | formatNumber }} / {{ electric_meter_change.new_meter_number }}</td>
                <td class="text-right text-no-wrap" v-else>{{ bill.room_bill_with_debts.electric.start | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối kỳ ({{ bill.date_out | formatTimeVN }})</td>
            <td class="text-right text-no-wrap" v-if="electric_meter_change">{{ electric_meter_change.old_meter_number }} / {{ bill.room_bill_with_debts.electric.end | formatNumber }}</td>
            <td class="text-right text-no-wrap" v-else>{{ bill.room_bill_with_debts.electric.end | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">{{ bill.room_bill_with_debts.electric.consume | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.room_bill_with_debts.electric.total_bill | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                Tiền nước
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">{{ bill.water_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu kỳ ({{ bill.room_bill_with_debts.water.startDate | formatTimeVN }})</td>
            <td class="text-right text-no-wrap" v-if="water_meter_change">{{ bill.room_bill_with_debts.water.start | formatNumber }} / {{ water_meter_change.new_meter_number }}</td>
            <td class="text-right text-no-wrap" v-else>{{ bill.room_bill_with_debts.water.start | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối kỳ ({{ bill.date_out | formatTimeVN }})</td>
            <td class="text-right text-no-wrap" v-if="water_meter_change">{{ water_meter_change.old_meter_number }} / {{ bill.room_bill_with_debts.water.end | formatNumber }}</td>
            <td class="text-right text-no-wrap" v-else>{{ bill.room_bill_with_debts.water.end | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">{{ bill.room_bill_with_debts.water.consume | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.room_bill_with_debts.water.total_bill | formatNumber }}</td>
        </tr>

        <tr>
            <td class="font-weight-bold" colspan="2">
                Tiền dịch vụ  (từ {{ bill.room_bill_with_debts.trash.startDate | formatTimeVN }} đến {{ bill.date_out | formatTimeVN }})
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">
                -- Tiền rác và vệ sinh
            </td>
            <td class="text-right text-no-wrap">
                {{ bill.room_bill_with_debts.trash.total_bill | formatNumber }}
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">
                -- Tiền xe
            </td>
            <td class="text-right text-no-wrap">
                {{
                    bill.room_bill_with_debts.vehicle.total_bill
                        | formatNumber
                }}
            </td>
        </tr>
        <template v-if="bill.room_bill_with_debts.washingMachine.total_bill > 0">
            <tr>
                <td class="text-left text-no-wrap">
                    -- Tiền máy giặt
                </td>
                <td class="text-right text-no-wrap">{{ bill.room_bill_with_debts.washingMachine.total_bill | formatNumber }}</td>
            </tr>
        </template>
        <template v-if="bill.room_bill_with_debts.airConditioner.total_bill > 0">
            <tr>
                <td class="text-left text-no-wrap">
                    -- Tiền máy lạnh
                </td>
                <td class="text-right text-no-wrap">{{ bill.room_bill_with_debts.airConditioner.total_bill | formatNumber }}</td>
            </tr>
        </template>
        <template v-if="bill.room_bill_with_debts.internet.total_bill > 0">
            <tr>
                <td class="text-left text-no-wrap">
                    -- Tiền Internet
                </td>
                <td class="text-right text-no-wrap">{{ bill.room_bill_with_debts.internet.total_bill | formatNumber }}</td>
            </tr>
        </template>
        <tr>
            <td class="font-weight-bold">
                Thành tiền
            </td>
            <td class="text-right text-no-wrap">{{ (
                bill.room_bill_with_debts.trash.total_bill +
                bill.room_bill_with_debts.vehicle.total_bill +
                bill.room_bill_with_debts.airConditioner.total_bill +
                bill.room_bill_with_debts.internet.total_bill +
                bill.room_bill_with_debts.washingMachine.total_bill
            ) | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left">TỔNG CỘNG</td>
            <td class="text-right">{{ bill.room_bill_with_debts.total_bill | formatNumber}} ₫</td>
        </tr>
        <tr>
            <td colspan="2">
                <hr>
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">
                Số tiền trả trước
            </td>
            <td class="text-right text-no-wrap font-weight-bold" style="width: 200px">{{ (bill.deposit_amount + bill.bill_paid_amount) | formatNumber }} ₫</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap " style="width: 200px">Tiền cọc:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.deposit_amount  | formatNumber }} ₫</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap " style="width: 200px">Tiền phòng trả trước:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.bill_paid_amount | formatNumber}} ₫</td>
        </tr>
        <tr v-if="other_fine_amount || bill.fine_amount">
            <td class="font-weight-bold" colspan="2">
                <hr>
                Số tiền phạt
            </td>
        </tr>
        <tr v-if="bill.fine_status != 0 && bill.fine_status_text">
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">{{ bill.fine_status_text}}:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{bill.fine_amount | formatNumber}} ₫</td>
        </tr>
        <tr v-if="other_fine_amount">
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Phạt khác:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ other_fine_amount | formatNumber}} ₫</td>
        </tr>
        <tr v-if="previous_months_debt">
            <td class="font-weight-bold" colspan="2">
                <hr>
                Tiền nợ các tháng trước
            </td>
        </tr>
        <tr v-if="previous_months_debt">
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Số tiền nợ:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ previous_months_debt | formatNumber }} ₫</td>
        </tr>
        <tr>
            <td colspan="2">
                <hr>
            </td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap" style="width: 200px">Số tiền trả cọc:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.amount && Number(bill.amount.toString().replace(" ₫", '').replace(/\./g, '')) | formatNumber}} ₫</td>
        </tr>
    </table>
</div>
</template>
<script>

import moment from "moment";

export default {
    props: {
        bill: Object,
    },
    name: "return-deposit-bill-detail",
    data(){
        console.log("🚀 ~ bill new:", this.bill)
        const date_schedule_out = this.bill.date_schedule_out ? this.bill.date_schedule_out : (this.bill.check_outs && this.bill.check_outs[0] ? this.bill.check_outs[0].date_schedule_out : null);
        const is_date_out_and_date_schedule_out_different_month = this.checkDiffDate(this.bill.date_out, date_schedule_out);
        return {
            water_meter_change: this.getWaterMeterChange(),
            electric_meter_change: this.getElectricMeterChange(),
            date_schedule_out,
            is_date_out_and_date_schedule_out_different_month,
        }
    },
    computed: {
        startDate(){
            if (this.bill.is_include_checkin_month_debt) {
                return (new Date(this.bill.date_in));
            } else {
                return (new Date(this.bill.date_out)).setDate(1);
            }
        },
        previous_months_debt(){
            if (!this.bill.previous_months_debt) return 0
            // Strip tất cả ký tự non-digit (NBSP, ₫, dấu chấm thousand separator, v.v.)
            const raw = this.bill.previous_months_debt.toString().replace(/\D/g, '')
            return Number(raw) || 0
        },
        other_fine_amount(){
            return this.bill.other_fine_amount ? Number(this.bill.other_fine_amount.toString().replace(" ₫", '').replace(/\./g, '')) : 0
        },
    },
    watch: {
        bill: {
            handler(newVal) {
                if (newVal) {
                    this.water_meter_change = this.getWaterMeterChange()
                    this.electric_meter_change = this.getElectricMeterChange()
                    this.date_schedule_out = this.bill.date_schedule_out ? this.bill.date_schedule_out : (this.bill.check_outs && this.bill.check_outs[0] ? this.bill.check_outs[0].date_schedule_out : null);
                    this.is_date_out_and_date_schedule_out_different_month = this.checkDiffDate(this.bill.date_out, this.date_schedule_out);
                }
            },
            deep: true
        }
    },
    methods: {
        getWaterMeterChange(){
            let water_meter_change = null
            if (this.bill.water_meter_change) {
                water_meter_change = this.bill.water_meter_change
            } else if (this.bill.last_month_payment && this.bill.last_month_payment.water_meter_change) {
                water_meter_change = this.bill.last_month_payment.water_meter_change
            }
            return water_meter_change;
        },
        getElectricMeterChange(){
            let electric_meter_change = null
            if (this.bill.electric_meter_change) {
                electric_meter_change = this.bill.electric_meter_change
            } else if (this.bill.last_month_payment && this.bill.last_month_payment.electric_meter_change) {
                electric_meter_change = this.bill.last_month_payment.electric_meter_change
            }
            return electric_meter_change;
        },
        checkDiffDate(date, date2){
            return moment(date).format('YYYY-MM-DD') !== moment(date2).format('YYYY-MM-DD');
        }
    }
}
</script>
<style scoped>
    .font-weight-bold {
        font-weight: 700 !important;
    }
    .font-weight-black {
        font-weight: 900 !important;
    }
    .mx-auto {
        margin: 0 auto;
    }
    .text-center {
        text-align: center;
    }
    .text-right {
    text-align: right;
    }
    .text-no-wrap {
        white-space: nowrap !important;
    }
    .text-left {
        text-align: left;
    }
</style>